import { all } from 'redux-saga/effects';
import helpCenterSaga from './helpCenter';

export default function* helpCenterModuleSaga() {
  yield all([helpCenterSaga()]);
}
